import RoomAllotmentTenantContactEdit from './RoomAllotmentTenantContactEdit.vue';

export default RoomAllotmentTenantContactEdit;